<div class="dashboard-home">
  <div class="white_box mb-4">
    <div class="d-flex align-items-center info-box">
      <div class="circle_icon">
        <i class="fa-solid fa-table-cells"></i>
      </div>
      <h3 class="heading_mid ml-3 m-0">
        <div class="heading_mid-title" (click)="dropdownPrice = !dropdownPrice">
          Monthly Base Rate
          <i class="fa-solid fa-angle-down"></i>
        </div>
        <p>Pay for your monthly base rate on a subscription basis</p>
      </h3>
    </div>
    <div class="my-dropdown" [class.active]="dropdownPrice">
      <div class="mt-4 d-flex space-between card_top">
        <div class="card_title">
          {{ total_txn }}
          <span class="text-small">Available VIP tokens</span>
        </div>
        <div class="icon">
          <i class="fa fa-dollar"></i>
        </div>
      </div>
      <div class="footer_actions">
        <p (click)="managesubscription(2)">Manage Subscription - KaChiing</p>
        <p (click)="managesubscription(1)">Manage Subscription - MYVIP</p>
        <p (click)="view_all_transactions(view_all_transactions_popup)">View all transactions</p>
      </div>
    </div>
  </div>
  <div class="title mt-5">
    <h2>Subscription - KaChiing</h2>
  </div>
  <h5 class="dash_subheading">Subscription is for Review QR and URL. If unsure please do contact the Help Centre before purchase</h5>
  <div class="purchase_div">
    <div class="job_plan mb-4 mt-4">
      <div class="row">
        <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
          <div class="card pt-3 text-center">
            <h3>
              <b class="pricing-heading">Enterprise</b> <br />

            </h3>
            <br />
            <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
              <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
            </div>

            <p class="setprice">$ 199/mo</p>

            <p class="snatcoin biz">Biz</p>

            <span class="save_info"> SAVE 50% </span>

            <a class="yellow_btn mx-auto my-3" (click)="subscribeto(7)">Buy now</a>
          </div>
        </div>

        <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
          <div class="card pt-3 text-center">
            <h3><b class="pricing-heading">Ultimate</b> <br /></h3>
            <br />
            <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
              <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
            </div>

            <p class="setprice">$ 299/mo</p>

            <p class="snatcoin biz">Biz</p>

            <span class="save_info"> SAVE 70% </span>

            <a class="yellow_btn mx-auto my-3" (click)="subscribeto(8)">Buy now</a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="title mt-5">
      <h2>Subscription - MYVIP <i class="fa-sharp fa-solid" [ngClass]="isSectionVisible ? 'fa-caret-up' : 'fa-caret-down'" (click)="toggleSectionmain()"></i></h2>
    </div>
    <h5 class="dash_subheading">Subscription is for Review QR and URL. If unsure please do contact the Help Centre before purchase</h5>
    <div class="purchase_div" id="sectionhide1" [style.display]="isSectionVisible ? 'block' : 'none'">
      <div class="job_plan mb-4 mt-4">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3>
                <b>Biz </b><br />
                <small>1 Link</small>
              </h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 149/mo</p>

              <span class="save_info bg-transparent"> </span>

              <p class="snatcoin biz">Biz</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(1)">Buy now</a>
            </div>
          </div>

          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3>
                <b>Enterprise</b> <br />
                <small>2 Links</small>
              </h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 219/mo</p>

              <p class="snatcoin biz">Biz</p>

              <span class="save_info"> SAVE 50% </span>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(2)">Buy now</a>
            </div>
          </div>

          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Ultimate</b> <br /><small> 3 Links</small></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 259/mo</p>

              <p class="snatcoin biz">Biz</p>

              <span class="save_info"> SAVE 70% </span>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(3)">Buy now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="title mt-5">
      <h2>Single Purchase Tokens</h2>
    </div>
    <h5 class="dash_subheading">Subscription is for Review QR and URL. If unsure please do contact the Help Centre before purchase</h5>
    <div class="purchase_div">
      <div class="job_plan mb-4 mt-4">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-12 mb-4" *ngFor="let i of products">
            <div class="card pt-3 text-center">
              <h3>{{ i.metadata.name }}</h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="{{ i.images[0] }}" alt="" />
              </div>
              <p class="snatcoin">{{ i.metadata.tokens }} VIP tokens</p>
              <p class="setprice">$ {{ i.metadata.price }}</p>

              <span class="save_info bg-transparent" *ngIf="i.metadata.name == 'MINI'"> </span>

              <span class="save_info" *ngIf="i.metadata.name != 'MINI'"> SAVE {{ i.metadata.save }}% </span>

              <a class="yellow_btn mx-auto my-3" (click)="stripe(i.default_price, i.metadata.tokens, i.metadata.name)"> Buy now </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="title mt-5">
      <h2>Custom Subscription - KaChiing</h2>
    </div>
    <h5 class="dash_subheading">Subscription is for Review QR and URL. If unsure please do contact the Help Centre before purchase</h5>
    <div class="purchase_div">
      <div class="job_plan mb-4 mt-4">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Custom 1 </b></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 255/mo</p>

              <span class="save_info bg-transparent"> </span>

              <p class="snatcoin biz">Custom 1</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(9)">Buy now</a>
            </div>
          </div>

          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Custom 2</b></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 759/mo</p>

              <span class="save_info bg-transparent"> </span>
              <p class="snatcoin biz">Custom 2</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(10)">Buy now</a>
            </div>
          </div>

          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Custom 3</b></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 1450/mo</p>

              <span class="save_info bg-transparent"> </span>
              <p class="snatcoin biz">Custom 3</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(11)">Buy now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="title mt-5">
      <h2>Custom Subscription - MYVIP <i class="fa-sharp fa-solid" [ngClass]="isSectionVisiblec ? 'fa-caret-up' : 'fa-caret-down'" (click)="toggleSectionc()"></i></h2>
    </div>
    <h5 class="dash_subheading">Subscription is for Review QR and URL. If unsure please do contact the Help Centre before purchase</h5>
    <div class="purchase_div" id="sectionhide2" [style.display]="isSectionVisiblec ? 'block' : 'none'">
      <div class="job_plan mb-4 mt-4">
        <div class="row">
          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Custom 1 </b></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 255/mo</p>

              <span class="save_info bg-transparent"> </span>

              <p class="snatcoin biz">Custom 1</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(4)">Buy now</a>
            </div>
          </div>

          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Custom 2</b></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 759/mo</p>

              <span class="save_info bg-transparent"> </span>
              <p class="snatcoin biz">Custom 2</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(5)">Buy now</a>
            </div>
          </div>

          <div class="col-xl-4 col-lg-6 col-md-12 mb-4">
            <div class="card pt-3 text-center">
              <h3><b>Custom 3</b></h3>

              <div class="doller_icon mx-auto d-flex align-items-center justify-content-center">
                <img loading="lazy" src="../../../assets/images/new/coin$s.svg" alt="" />
              </div>

              <p class="setprice">$ 1450/mo</p>

              <span class="save_info bg-transparent"> </span>
              <p class="snatcoin biz">Custom 3</p>

              <a class="yellow_btn mx-auto my-3" (click)="subscribeto(6)">Buy now</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<ng-template #view_all_transactions_popup let-modal>
  <button type="button" class="close close_modal" style="outline: none" (click)="modal.dismiss('Cross click')" data-dismiss="modal"><span aria-hidden="true">×</span></button>

  <div class="modal-header">
    <h5 class="modal_title">VIP Tokens Report</h5>
  </div>
  <div class="modal-body p-4">
    <div class="row">
      <div class="col-md-12 add_ded_tbl">
        <table class="table">
          <thead class="thead-light">
            <tr>
              <th scope="col">Sr.No.</th>
              <th scope="col">Detail</th>
              <th scope="col">VIP Tokens</th>
              <th scope="col">Txn. Status</th>
              <th scope="col">Ded. From</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let i of transactions; let a = index">
              <th scope="row">{{ a + 1 }}</th>
              <td>
                <span *ngIf="i.add_deduct == 'add'">Add VIP Token</span>
                <span *ngIf="i.add_deduct == 'deduct'">Deduct VIP Token</span>
              </td>
              <td>{{ i.tokens }}</td>
              <td>
                <span *ngIf="i.add_deduct == 'add'">{{ i.status }}</span>
                <span *ngIf="i.add_deduct == 'deduct'">complete</span>
              </td>
              <td>
                <span *ngIf="i.type == 0"><i class="fas fa-coins"></i></span>
                <span *ngIf="i.type == 1"><i class="fab fa-google"></i></span>
                <span *ngIf="i.type == 2"><i class="fab fa-instagram"></i></span>
                <span *ngIf="i.type == 3"><i class="fab fa-twitter"></i></span>
                <span *ngIf="i.type == 4"> GM {{ i.show }} </span>
                <span *ngIf="i.type == 5"> ST {{ i.show }} </span>
                <span *ngIf="i.type == 6"> {{ i.show }} </span>
              </td>
              <td>{{ i.created * 1000 | date : "medium" }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</ng-template>
